const Label = ({ children, style, ...props }) => (
    <span
        style={{
            fontFamily: "Roboto Medium, Helvetica, sans-serif",
            fontWeight: 500,
            ...style
        }}
        {...props}
    >
        {children}
    </span>
);

export default Label;